import * as React from 'react';
const SvgMap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={240}
    fill="none"
    viewBox="0 0 241 240"
    {...props}
  >
    <path
      fill="#E9F2FF"
      d="M120.5 204c46.392 0 84-37.608 84-84s-37.608-84-84-84-84 37.608-84 84 37.608 84 84 84"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M172 209.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M212 86.398a1.9 1.9 0 0 0 1.904-1.898A1.9 1.9 0 0 0 212 82.603a1.9 1.9 0 0 0-1.904 1.897c0 1.042.847 1.897 1.904 1.897M212 89a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M69 30.398a1.9 1.9 0 0 0 1.904-1.898A1.9 1.9 0 0 0 69 26.602a1.9 1.9 0 0 0-1.904 1.898A1.9 1.9 0 0 0 69 30.398M69 33a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M177.508 17.568c.505-2.09 3.478-2.09 3.983 0l.764 3.166c.18.747.764 1.33 1.511 1.51l3.166.765c2.09.504 2.09 3.478 0 3.982l-3.166.765a2.05 2.05 0 0 0-1.511 1.51l-.764 3.166c-.505 2.09-3.478 2.09-3.983 0l-.764-3.166a2.05 2.05 0 0 0-1.511-1.51l-3.166-.765c-2.09-.504-2.09-3.478 0-3.982l3.166-.765a2.05 2.05 0 0 0 1.511-1.51zM71.396 195.655c.534-2.207 3.674-2.207 4.208 0l.712 2.941a2.17 2.17 0 0 0 1.597 1.595l2.929.705c2.21.532 2.21 3.676 0 4.208l-2.928.705c-.79.19-1.407.806-1.598 1.595l-.712 2.941c-.534 2.207-3.674 2.207-4.208 0l-.712-2.941a2.17 2.17 0 0 0-1.597-1.595l-2.929-.705c-2.21-.532-2.21-3.676 0-4.208l2.928-.705a2.17 2.17 0 0 0 1.598-1.595z"
    />
    <path
      fill="#8BF"
      d="M150.408 185.029c1.351-.244 2.452 1.114 1.981 2.444l-2.587 7.318c-.47 1.33-2.159 1.636-3.04.549l-4.844-5.975c-.881-1.086-.293-2.75 1.058-2.994z"
    />
    <path
      fill="#fff"
      d="m48.5 74 38-10 34 10 34-10 38 10 34 100-60-21-46 23-46-23-60 21z"
    />
    <path fill="#59F" d="m154.5 64 38 10 34 100-60-21z" opacity={0.6} />
    <path fill="#59F" d="m154.5 64-34 10v102l46-23z" opacity={0.4} />
    <path fill="#59F" d="m86.5 64 34 10v102l-46-23z" opacity={0.6} />
    <path fill="#59F" d="m86.5 64-38 10-34 100 60-21z" opacity={0.4} />
    <path
      fill="#59F"
      fillRule="evenodd"
      d="m120.5 74-34-10-38 10-34 100 60-21 46 23 46-23 60 21-34-100-38-10zm34.7-4.8L120.5 78l-34.7-8.8-34.3 9.443-24.138 82.379 47.69-16.691 45.448 22.725 45.449-22.725 47.689 16.691L189.5 78.643z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M93.826 99.202a26.7 26.7 0 0 0-5.799.09l-.487-3.97a30.7 30.7 0 0 1 6.666-.102zm10.911 3.648a27 27 0 0 0-5.258-2.444l1.276-3.79a30.8 30.8 0 0 1 6.041 2.805zm-22.428-2.281a37 37 0 0 0-5.465 2.274l-1.82-3.562a41 41 0 0 1 6.058-2.52zm-10.567 5.361a46 46 0 0 0-4.658 3.752l-2.705-2.947a50 50 0 0 1 5.062-4.077zm41.842 4.669a40 40 0 0 0-4.121-4.258l2.653-2.994a44.4 44.4 0 0 1 4.532 4.68zm66.969-5.587c-.358 2.141-1.033 4.315-1.962 6.455l-3.669-1.593c.819-1.887 1.389-3.747 1.686-5.523zm-117.605 8.997a38 38 0 0 0-3.448 4.82l-3.432-2.053a42 42 0 0 1 3.81-5.33zm112.46 3.26a44 44 0 0 1-4.048 5.177l-2.96-2.691a40 40 0 0 0 3.679-4.702zm-45.854 13.114a33.7 33.7 0 0 1-4.952-4.427l2.936-2.716c1.426 1.541 2.885 2.833 4.362 3.903zm37.057-3.419a42.5 42.5 0 0 1-5.385 3.776l-2.031-3.446a38.5 38.5 0 0 0 4.877-3.42zm-11.36 6.628c-2.1.774-4.27 1.339-6.482 1.646l-.55-3.962a27 27 0 0 0 5.648-1.437zm-13.237 1.74a25.4 25.4 0 0 1-6.571-1.672l1.493-3.711a21.3 21.3 0 0 0 5.537 1.409z"
      clipRule="evenodd"
    />
    <ellipse cx={56.5} cy={123} fill="#05C" opacity={0.6} rx={8} ry={3} />
    <path
      fill="#05C"
      d="M58 116.623V95h-3v21.623c0 3.942.919 6.377 1.507 6.377.603 0 1.493-2.42 1.493-6.377"
    />
    <path
      fill="#16E"
      d="M73.071 96C79.847 96 84.5 91.713 84.5 85.46c0-4.914-3.02-8.928-7.728-10.293-.816-9.12-8.435-16.11-17.497-16.11-7.02 0-12.625 3.796-15.7 9.72-8.3.028-14.45 5.844-14.45 13.598 0 7.7 5.987 13.625 13.742 13.625z"
    />
    <path
      fill="#FEA262"
      d="M32.935 50.621c1.36 0 2.477-1.147 2.477-2.485v-5.651A2.49 2.49 0 0 0 32.935 40c-1.333 0-2.449 1.12-2.449 2.485v5.651c0 1.338 1.116 2.485 2.45 2.485m16.164 5.27 3.972-4.014a2.494 2.494 0 0 0 0-3.495c-.925-.928-2.503-.955-3.455 0l-4 4.041c-.953.983-.925 2.54 0 3.468.925.955 2.503.983 3.483 0m-28.817 0c.925-.928.953-2.512 0-3.468l-4.027-4.013a2.44 2.44 0 0 0-3.456 0c-.952.928-.952 2.512 0 3.467l4 4.014c.953.983 2.558.955 3.483 0m5.415 24.355C26.595 72 32.637 66.32 41.48 65.638c.843-1.61 1.85-2.921 3.02-4.123-2.258-3.931-6.585-6.58-11.565-6.58-7.537 0-13.605 6.089-13.605 13.652 0 4.805 2.449 9.01 6.367 11.659m-13.115-9.202c1.333 0 2.476-1.092 2.476-2.43 0-1.365-1.143-2.484-2.476-2.484H6.949c-1.36 0-2.449 1.12-2.449 2.484a2.437 2.437 0 0 0 2.449 2.43zm3.673 17.775 4.027-4.014a2.46 2.46 0 0 0 0-3.467c-.952-.956-2.503-.928-3.456 0l-4 4.014a2.487 2.487 0 0 0-.027 3.467 2.44 2.44 0 0 0 3.456 0"
    />
    <ellipse cx={179.5} cy={100} fill="#05C" opacity={0.6} rx={8} ry={3} />
    <path
      fill="#F77167"
      fillRule="evenodd"
      d="M179.5 99c-4.94 0-13-19.311-13-26.667 0-3.533 1.365-6.933 3.813-9.422A12.77 12.77 0 0 1 179.5 59c3.445 0 6.76 1.4 9.187 3.911a13.48 13.48 0 0 1 3.813 9.422c0 7.356-8.06 26.667-13 26.667"
      clipRule="evenodd"
    />
    <ellipse cx={179.81} cy={72.438} fill="#fff" rx={9.595} ry={9.688} />
    <ellipse cx={120.5} cy={118} fill="#05C" opacity={0.6} rx={16} ry={5} />
    <path
      fill="#05C"
      d="M125.5 97.744V8h-10v89.744c0 13.14 3.062 21.256 5.024 21.256 2.009 0 4.976-8.068 4.976-21.256"
    />
    <path
      fill="#59F"
      d="M94.5 20a4 4 0 0 1 4-4h57.409c1.151 0 2.246.496 3.005 1.36l5.269 6a4 4 0 0 1 0 5.28l-5.269 6a4 4 0 0 1-3.005 1.36H98.5a4 4 0 0 1-4-4z"
    />
    <path
      fill="#8BF"
      d="M146.5 44a4 4 0 0 0-4-4H85.091a4 4 0 0 0-3.005 1.36l-5.269 6a4 4 0 0 0 0 5.28l5.269 6A4 4 0 0 0 85.09 60H142.5a4 4 0 0 0 4-4z"
    />
  </svg>
);
export default SvgMap;
